import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResumeScore from '../components/ResumeScore';

// Self-service page for a student to score their own uploaded resume.
export default function ResumeScorePage() {
  const navigate = useNavigate();
  return (
    <div style={{ maxWidth: 760, margin: '0 auto', padding: '24px 16px' }}>
      <button
        className="btn btn-secondary btn-sm"
        onClick={() => navigate('/student/dashboard')}
        style={{ marginBottom: 16 }}
      >
        ← Back to Dashboard
      </button>
      <h2 style={{ margin: '0 0 4px' }}>Resume Score</h2>
      <p style={{ color: '#6b7280', margin: 0 }}>
        See how your resume scores against open-source, projects, production and
        technical-skill signals.
      </p>
      <ResumeScore />
    </div>
  );
}
